import { FC } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "../src/router/router";
import { Providers } from "./providers/Providers";

export const App: FC = () => {

  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
};
